import React, { useEffect, useState } from "react";
import EyeIcon from "../../common/assests/eyegreen.png";
import Adminimg from "../../common/assests/adminimg.png";
import CrossIcon from "../../common/assests/croosicon.png";
import DeletIcon from "../../common/assests/deleticon.png";
import SearchItem from "../../common/assests/search.svg";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  Modal,
  TextField,
  InputAdornment,
  Card,
} from "@mui/material";
import Paginations from "../../common/pagination/Paginations";
import TestingImg from "../../common/assests/gridimg3.png";
import Clock from "../../common/assests/clock.svg";
import { allVendorProductsApi, deleteProductApi, venderProductDetailApi } from "../../api";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../common/loader/Loader";
import UserImg from "../../common/assests/sampleuser.svg";
import CompanyLogo from "../../common/assests/reyleafLogo.svg";
import StarIcon from "@mui/icons-material/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { toast } from "react-toastify";
import TableComp from "../../common/tablecomp/TableComp";
import VenderAllProductRow from "../../common/tablerow/VenderAllProductRow";
import configuration from "../../config/Config";


const AllProductList = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [allVenderProducts, setAllVenderProducts] = useState([]);
  const [productDetailsData, setProductDetailsData] = useState({});
  const [myTimout, setMyTimeOut] = useState();
  const [change, setChange] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleAllProducts = async () => {
    try {
      setLoading(true);
      const response = await allVendorProductsApi({
        token,
        currentPage,
        id,
        searchQuery,
      });
      setAllVenderProducts(response?.products || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleProductDetails = async (id) => {
    try {
      setLoading(true);
      const response = await venderProductDetailApi({ token, id });
      setProductDetailsData(response || {});
      // console.log("v products details", response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleDeleteProduct=async(id)=>{
    const isConfirmed = window.confirm("Are you sure, you want to Delete this Product?");
    if (!isConfirmed) {
      return;
    }
    try {  
      const response = await deleteProductApi({token,id});
      setChange(!change)
      toast.success(response.message)
    } catch (error) {
      toast.error(error.message)
      console.log("error", error);
    }
  }

  const handleClickOpen = (row) => {
    setSelectedRow(row);
    handleProductDetails(row?._id);
    setOpen(true);
  };

  // console.log("productDetailsData ", productDetailsData);

  useEffect(() => {
    handleAllProducts();
  }, [currentPage,change]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
  
      handleAllProducts();
    } else {

      clearTimeout(myTimout);
      const timeout = setTimeout(handleAllProducts, 500);
      setMyTimeOut(timeout);

    }
  }, [searchQuery]);
  

  // useEffect(() => {
  //   if(searchQuery.trim()!=""){
  //   clearTimeout(myTimout);
  //   setMyTimeOut(setTimeout(handleAllProducts, 500));
  //   }
  // }, [searchQuery]);

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

 
  const titles = [
    { title: "Image" },
    { title: "Name" },
    { title: "Category" },
    { title: "Description" },
    { title: "Review & Rating" },
    { title: "Price" },
    { title: "Discounted Price" },
    { title: "Status" },
    { title: "Action" },
  ];

  const StarRating = ({ rating }) => {
    const fullStars = Math.floor(rating);
    const decimal = rating - fullStars;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <StarIcon key={i} sx={{ color: "#FFD700", fontSize: "20px" }} />
      );
    }

    if (decimal > 0) {
      stars.push(
        <StarHalfIcon
          key="partial"
          sx={{ color: "#FFD700", fontSize: "20px" }}
        />
      );
    }

    for (let i = stars.length; i < 5; i++) {
      stars.push(
        <StarOutlineIcon key={i} sx={{ color: "#FFD700", fontSize: "20px" }} />
      );
    }

    return <div>{stars}</div>;
  };

  return (
    <div>
      {loading ? (
        <Loader variant="table" />
      ) : (

        <Card
            backgroundColor={"#fff"}
            borderRadius={"35px"}
            sx={{ padding: "20px", borderRadius: "25px",marginTop: "40px", marginBottom: "30px"  }}
            >
      
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "16px", sm: "20px" },
                  fontWeight: "600",
                  color: "#362B24",
                }}
              >
                Product List
              </Typography>
              <TextField
                placeholder="Search by name"
                value={searchQuery}
                onChange={(e) => {
                  if (e.target.value.trim() !== "" || e.target.value === "") {
                    setSearchQuery(e.target.value);
                  }
                }}
                sx={{
                  width: { xs: "60%", sm: 240 },
                  height: { xs: 48 },
                  flexShrink: 0,
                  borderRadius: "33px",
                  background: "#EBEBEB",

                  border: "none",
                  "& .MuiOutlinedInput-input": {
                      height: "30%",
                    },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "33px",
                    height: "100%",
                    paddingRight: "10px",
                    outline: "none",
                    border: "none",
                    
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={SearchItem}
                        sx={{ color: "#000", opacity: "0.35" }}
                      />
                    </InputAdornment>
                  ),
                  style: { height: "100%" },
                }}
              />
            </Box>

            <TableComp title={titles}>
              {allVenderProducts?.length > 0 ? (
                allVenderProducts?.map((item) => (               
                  <VenderAllProductRow 
                    key={item?._id}
                    item={item}
                    handleViewMore={() => handleClickOpen(item)}
                    StarRatingComponent={StarRating}
                    viewMore ={()=>handleClickOpen(item)}
                    deleteItem={()=>handleDeleteProduct(item?._id)}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={titles.length} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableComp>

            <Paginations
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            disabled={loading}
            />
            </Card>
  
      )}

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            // maxWidth: '874px',
            maxWidth: "630px",
            width: "90%",
            maxHeight: "80vh",
            bgcolor: "#F5F5F5",
            borderRadius: "24px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            p: "20px",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
              Product Details
            </Typography>
            <IconButton onClick={handleClose}>
              <img
                src={CrossIcon}
                alt="img"
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
            </IconButton>
          </Box>

          {selectedRow && (
            <Box sx={{ marginTop: "20px" }}>
              <img
                src={
                  selectedRow?.photos && selectedRow.photos.length > 0
                    ? `${configuration.cdnFront}/${selectedRow.photos[0].url}`
                    : UserImg
                }
                alt={"Img"}
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "231px",
                  borderRadius: "24px",
                  marginBottom: "20px",
                }}
              />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(100px, 0fr))",
                  gap: "5px",
                }}
              >
                {selectedRow?.photos?.map((image) => (
                  <Box
                    key={image?._id}
                    sx={{
                      width: "77px",
                      height: "79px",
                      flexShrink: 0,
                      borderRadius: "16px",
                      boxShadow: "3px 2px 20px 0px rgba(0, 0, 0, 0.04)",
                      overflow: "hidden",
                      "@media (max-width: 767px)": {
                        width: "100%",
                        height: "auto",
                      },
                    }}
                  >
                    <img
                      src={
                        image?.url
                          ? `${configuration.cdnFront}/${image.url}`
                          : UserImg
                      }
                      alt="img"
                      style={{
                        width: "100%",

                        height: "100%",
                        maxHeight: "80px",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
              </Box>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 0fr))",
                  gap: 3,
                  marginTop: "25px",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "13px",
                      opacity: "0.6",
                      color: "#362B24",
                    }}
                  >
                    Product Name
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{selectedRow?.title || "N/A"}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "13px",
                      opacity: "0.6",
                      color: "#362B24",
                    }}
                  >
                    Product Category
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{selectedRow?.categoryId?.name || "-"}</strong>
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      opacity: "0.6",
                      color: "#362B24",
                      fontSize: "15px",
                    }}
                  >
                    Price
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{`$${selectedRow?.price || "-"}`}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "13px",
                      opacity: "0.6",
                      color: "#362B24",
                    }}
                  >
                    Discount Price
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{`$${selectedRow?.discountedProce || "-"}`}</strong>
                  </Typography>
                </Box>
             
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "#362B24",
                    marginTop: "20px",
                  }}
                >
                  Description
                </Typography>
                <Typography
                  sx={{
                    fontSize: "13px",
                    opacity: "0.5",
                    color: "#362B24",
                    fontWeight: "400",
                    lineHeight: "24px",
                  }}
                >
                  {selectedRow?.description || "N/A"}
                </Typography>
              </Box>

              
                  <Box >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "16px",
                        color: "#362B24",
                        marginTop: "20px",
                      }}
                    >
                      Review & Rating
                    </Typography>


              {productDetailsData?.reviews?.length > 0 ? (
                productDetailsData?.reviews?.map((reviewsItem) => (      
                    <>
                    <Box
                    key={reviewsItem._id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: "10px",
                        gap: "20px",
                        flexWrap: "wrap",
                        paddingBottom: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "20px",
                        }}
                      >
                        {/* Image */}
                        <img
                          src={
                            reviewsItem?.user?.picture
                              ? `${configuration.cdnFront}/${reviewsItem?.user?.picture}`
                              : UserImg
                          }
                          alt="Reviewer"
                          style={{
                            width: "46px",
                            height: "46px",
                            borderRadius: "50%",
                          }}
                        />

                        {/* Reviewer Details */}
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: "700",
                              fontSize: "14px",
                              color: "#362B24",
                            }}
                          >
                            {reviewsItem?.user?.fullname || "N/A"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              color: "#065F46",
                              fontWeight: "400",
                              marginTop: "5px",
                            }}
                          >
                            <img src={Clock} className="me-2" alt="Clock icon" />
                            {reviewsItem?.createdAt ?  new Date(reviewsItem?.createdAt || "-").toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }):"-"}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Stars */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <StarRating rating={reviewsItem?.rating || "0"} />
                        <Typography sx={{ fontWeight: "600", fontSize: "15px" }}>
                          {reviewsItem?.rating || "0"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ borderBottom: "1px solid #E0E0E0" }}>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          opacity: "0.5",
                          color: "#362B24",
                          fontWeight: "400",
                          lineHeight: "24px",
                          marginBottom: "5px",
                        }}
                      >
                        {reviewsItem?.review || "N/A"}
                      </Typography>
                    </Box>
                    </>
                      ))
                    ):(
                    <div style={{textAlign:'center',marginTop:"20px"}}>No Reviews Available</div>
                    )}
                  </Box>
              
            </Box>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default AllProductList;
